/* eslint-disable import/first */
import './bootstrap';
import React from 'react';
import { ThemeProvider } from 'styled-components';
import { WingsProvider } from '@wingscms/react';
import { Provider as PluginOptionsProvider } from '../src/ctx/PluginOptions';
import createTheme from './theme';
import GlobalStyles from '../src/styles/global';
import wings from '../src/data/wings';
export default (function (_ref, pluginOptions) {
  var element = _ref.element;
  var design = pluginOptions.design,
      typography = pluginOptions.typography;
  return React.createElement(WingsProvider, {
    client: wings
  }, React.createElement(ThemeProvider, {
    theme: createTheme({
      design: design,
      typography: typography
    })
  }, React.createElement(PluginOptionsProvider, {
    value: pluginOptions
  }, React.createElement(React.Fragment, null, React.createElement(GlobalStyles, null), element))));
});